import { HttpTransportType, HubConnectionBuilder } from '@microsoft/signalr';
import { CookiesName } from '@/api';
import { useCookies } from 'vue3-cookies';
import loginRepository from '@/api/LoginRepository';
import {
  setAllCookies,
} from '@/services/utils';

const { cookies } = useCookies();

export const connection = new HubConnectionBuilder()
  .withUrl(`https://watop.games/hub/notifications`, {
    accessTokenFactory: () => cookies.get(CookiesName.token),
    skipNegotiation: false,
    transport: HttpTransportType.LongPolling,
  })
  .withAutomaticReconnect()
  .build();

const refresh = async () => {
  const response = await loginRepository.refresh(
    cookies.get(CookiesName.refreshToken),
  );
  setAllCookies(response);
};
